import forgetPwd from './forgetPwd';
import resetVerify from './resetVerify';
import resetPwdDo from './resetPwdDo';
import inviteVerify from './inviteVerify';
import logincompany from './logincompany';
import loginactivepwd from './loginactivepwd';
export default {
    forgetPwd,
    resetVerify,
    resetPwdDo,
    inviteVerify,
    /** 外部成员邀请：登录并接受邀请 */
    logincompany,
    /** 密码激活 */
    loginactivepwd,
};



// WEBPACK FOOTER //
// ./src/api/login/index.ts